import module from 'finanzas/module.js'
import template from './template.html'

export class FinancesSaldoempleadosExportarComponent {
  empresas
  fecha
}


module.component('financesSaldoempleadosExportar', {
  controller: FinancesSaldoempleadosExportarComponent,
  template,
  bindings: {
    empresas: '<',
    fecha: '<',
  },
})




// WEBPACK FOOTER //
// ./src/finanzas/components/saldoempleados/exportar/component.js